import { cronosClient } from "@/config/client"

type MilestoneType = "exam" | "reminder"

export interface UpdateMilestoneDto {
  title: string
  courseId: string
  date: string
  type: MilestoneType
  unitIds: string[]
}

export interface UpdateMilestoneRequest {
  payload: UpdateMilestoneDto
  milestoneId: string
}
export function update(data: UpdateMilestoneRequest) {
  return cronosClient.put(`/v1/milestones/${data.milestoneId}`, data.payload)
}
